import React, { ChangeEvent } from 'react'

import { SxProps } from '@mui/material'

import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import InputAdornment from 'components_new/atoms/InputAdornment'
import TextField from 'components_new/atoms/TextField'
import { useTranslation } from 'language/translator'

export interface SearchFieldProps {
  autoFocus?: boolean
  disabled?: boolean
  helperText?: string
  onBlur?: () => void
  onClear: () => void
  onFocus?: () => void
  onSearch: (value: string) => void
  placeholder?: string
  size?: 'small' | 'medium'
  sx?: SxProps
  value: string
}

const SearchField = (props: SearchFieldProps) => {
  const {
    autoFocus,
    disabled,
    helperText,
    onBlur,
    onClear,
    onFocus,
    onSearch,
    placeholder,
    size,
    sx,
    value
  } = props

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value)
  }

  const { t } = useTranslation()

  return (
    <>
      <TextField
        autoComplete="off"
        autoFocus={autoFocus}
        disabled={disabled}
        InputProps={{
          type: 'text',
          name: 'search',
          startAdornment: (
            <InputAdornment position="start">
              <Icon fontSize={size} name="Search" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {value ? (
                <IconButton onClick={onClear} size={size}>
                  <Icon fontSize={size} name="ClearOutlined" />
                </IconButton>
              ) : null}
            </InputAdornment>
          )
        }}
        helperText={helperText}
        onBlur={onBlur}
        onChange={handleSearch}
        onFocus={onFocus}
        placeholder={placeholder ?? t('global', 'search')}
        size={size}
        sx={{
          my: 0,
          ...sx
        }}
        value={value}
      />
    </>
  )
}

export default SearchField
